import { render, staticRenderFns } from "./EditProfileBreadcumb.vue?vue&type=template&id=590b3e74&scoped=true&"
import script from "./EditProfileBreadcumb.vue?vue&type=script&lang=js&"
export * from "./EditProfileBreadcumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590b3e74",
  null
  
)

export default component.exports